<p class="text-gray-500 text-left mb-2 text-xs">
  To personalize your experience, Event organizers for this event require additional information from each attendee, please fill out the required fields with details of the person whom you're buying this ticket for.
</p>

<form [formGroup]="dynamicForm" *ngIf="dynamicForm">
  <div formArrayName="eventFields" class="flex flex-col gap-4">
    <div
      *ngFor="let field of eventFieldsArray.controls; let i = index"
      [formGroupName]="i"
      class="flex flex-col gap-1"
    >
      <ng-container *ngIf="fields[i].fieldType === 'TEXT'">
        <label [for]="fields[i].name">
          {{ fields[i].displayName }}
          <span *ngIf="fields[i].mandatory" class="text-red-500">*</span>
        </label>
        <input
          nzSize="large"
          nz-input
          [id]="fields[i].name"
          [formControlName]="fields[i].name"
          type="text"
          class=" w-full"
        />
        <p *ngIf="isFieldInvalid(i)" class="text-xs text-red-500">This field is required.</p>
      </ng-container>

      <ng-container *ngIf="fields[i].fieldType === 'DATE'">
        <label [for]="fields[i].name">
          {{ fields[i].displayName }}
          <span *ngIf="fields[i].mandatory" class="text-red-500">*</span>
        </label>
        <nz-date-picker
          nzSize="large"
          class=" w-full"
          [formControlName]="fields[i].name"
        ></nz-date-picker>
        <p *ngIf="isFieldInvalid(i)" class="text-xs text-red-500">This field is required.</p>
      </ng-container>

      <ng-container *ngIf="fields[i].fieldType === 'TIME'">
        <label [for]="fields[i].name">
          {{ fields[i].displayName }}
          <span *ngIf="fields[i].mandatory" class="text-red-500">*</span>
        </label>
        <nz-time-picker
          nzSize="large"
          [formControlName]="fields[i].name"
          class=" w-full"
        ></nz-time-picker>
        <p *ngIf="isFieldInvalid(i)" class="text-xs text-red-500">This field is required.</p>
      </ng-container>

      <ng-container *ngIf="fields[i].fieldType === 'BOOLEAN'">
        <label [for]="fields[i].name">
          {{ fields[i].displayName }}
          <span *ngIf="fields[i].mandatory" class="text-red-500">*</span>
        </label>
        <nz-radio-group class=" w-full" [formControlName]="fields[i].name">
          <label nz-radio [nzValue]="true">Yes</label>
          <label nz-radio [nzValue]="false">No</label>
        </nz-radio-group>
        <p *ngIf="isFieldInvalid(i)" class="text-xs text-red-500">Please select an option.</p>
      </ng-container>

      <ng-container *ngIf="fields[i].fieldType === 'NUMBER'">
        <label [for]="fields[i].name">
          {{ fields[i].displayName }}
          <span *ngIf="fields[i].mandatory" class="text-red-500">*</span>
        </label>
        <input
          nzSize="large"
          [id]="fields[i].name"
          [formControlName]="fields[i].name"
          nz-input
          class=" w-full"
          type="number"
        />
        <p *ngIf="isFieldInvalid(i)" class="text-xs text-red-500">This field is required.</p>
      </ng-container>

      <ng-container *ngIf="fields[i].fieldType === 'SELECT'">
        <label [for]="fields[i].name">
          {{ fields[i].displayName }}
          <span *ngIf="fields[i].mandatory" class="text-red-500">*</span>
        </label>
        <nz-select class=" w-full" nzSize="large" [formControlName]="fields[i].name">
          <nz-option *ngFor="let option of fields[i].options" [nzLabel]="option" [nzValue]="option"></nz-option>
        </nz-select>
        <p *ngIf="isFieldInvalid(i)" class="text-xs text-red-500">This field is required.</p>
      </ng-container>

      <ng-container *ngIf="fields[i].fieldType === 'MULTIPLE_SELECT'">
        <label [for]="fields[i].name">
          {{ fields[i].displayName }}
          <span *ngIf="fields[i].mandatory" class="text-red-500">*</span>
        </label>
        <nz-select
          class=" w-full"
          nzSize="large"
          nzMode="multiple"
          [formControlName]="fields[i].name"
        >
          <nz-option *ngFor="let option of fields[i].options" [nzLabel]="option" [nzValue]="option"></nz-option>
        </nz-select>
        <p *ngIf="isFieldInvalid(i)" class="text-xs text-red-500">Please select at least one option.</p>
      </ng-container>
    </div>
  </div>
</form>

<div *nzModalFooter>
  <button nz-button nzType="default" (click)="cancel()">Cancel</button>
  <button nz-button nzType="primary" (click)="onSubmit()" [nzLoading]="loading">
    Submit</button
  >
</div>
